






















































import { computed, defineComponent } from "@vue/composition-api";
import { ContentFile } from "@scrile/api-provider/dist/api/ContentFilesProvider";
import { FileData } from "@scrile/api-provider/dist/api/FileProvider";
import { ProcessingStatus } from "@scrile/api-provider/dist/projects/scrileConnect/ContentFeedProvider";
import { MediaFilesController } from "@/lib/MediaFilesController";
import AudioPlayerController from "@/components/AudioPlayerController";
import BaseIcon from "@/components/BaseIcon";
import BaseImage from "@/components/BaseImage";
import BaseSpinner from "@/components/BaseSpinner";

export default defineComponent({
  name: "AudioPlayer",
  components: { BaseImage, BaseIcon, BaseSpinner, AudioPlayerController },
  props: {
    file: { type: Object as () => FileData | ContentFile, required: true },
    isAvailable: { type: Boolean, default: true },
    processingStatus: { type: String as () => ProcessingStatus, required: true },
  },
  setup(props) {
    const INPUT_STEP = 1;
    const MIN_RANGE_IS_SECONDS = 0;
    const audioSrc = computed(() => (props.file.urlPart ? MediaFilesController.getFileUrl(props.file.urlPart) : ""));
    const isShowDuration = computed(() => props.processingStatus === "OK");
    const processingError = computed(() => props.processingStatus === "ERROR");
    const isSpinnerShow = computed(() => props.processingStatus !== "OK" && !processingError.value);

    const inputFillLower = "var(--palette-gray-darken-4)";
    const inputFillUpper = "var(--palette-gray-lighten-4)";

    return {
      INPUT_STEP,
      MIN_RANGE_IS_SECONDS,
      audioSrc,
      isShowDuration,
      processingError,
      isSpinnerShow,
      inputFillLower,
      inputFillUpper,
    };
  },
});
